import axios from 'axios';
import {
    GET_PRODUCTS_BY_SUBCAT, LOADING_START, LOADING_END, ADD_PRODUCT_TOOLTIP, SET_ORDER_COMMENT, ADD_TO_CART,
    CLEAR_CART, ORDER_FAILED, ORDERED_SUCCESSFULLY, GET_ALL_PRODUCTS, LOADING_ORDER_START, LOADING_ORDER_END,
    ADD_TO_ORDERED, CLEAR_ORDER, CHANGE_SELECTED_CART_TAB, GET_ORDERS, BILL_ASKED, CLEAR_BILL_ASKED, LOADING_CART_START,
    LOADING_CART_END, ORDER_SPOT_FAILED, SET_PRODUCT_PAGE_ID, REMOVE_PRODUCT_PAGE_ID,
    OPEN_COMMENT_MODAL, COMMENT_MODAL_TITLE, COMMENT_VARIANT_ID, COMMENT_CART_ITEM_UUID, PAYMENT_TYPE_MODAL_OPENED, SET_DISABLED_MAKE_ORDER_BUTTON,
    LIST_INGREDIENTS, LIST_INGREDIENT_GROUPS, PLACE_IMAGE_UPLOADED, SET_UPSELLING_PRODUCTS_MODAL_OPENED, SET_ORDER_LOCATION_MODAL
} from './types';
import { CLEAR_PROMOCODE } from '../../promocodes/types';
import { API_URL, DEFAULT_PRODUCT_IMAGE, BILL_WANTED_EXPIRE_TIME_MINUTES } from '../../constants'
import { openScanModal, setCurrOpenedModal, closeScanModal, setOrderModalState } from './../../qr-scan/actions/scan.actions';
// import _ from 'lodash';
import Utils from '../../utils/Utils';
import Auth from '../../utils/Auth';
import history from './../../utils/history';
import { isEqual, sortBy } from 'lodash';
import ReactPixel from 'react-facebook-pixel';
import { addErrorMessages, addSuccessMessage } from './../../messages/messages.actions';
import { setErrorAndReloadModalMessage } from './../../menu/menu.actions';
import { updateRemoteCart, getCartIdLocal, removeCartIdLocal } from './../../cart/actions/cart.actions';
import { initiateEpayOrder, initiateEpayOrderOneTouch, setProcessingPaymentModalOpened } from './../../payments/epay/epay.actions'
import { startDatecsKioskPayment } from './../../payments/datecs/datecsKioskPayment'
import { maybePrintKioskReceipt } from './../../payments/datecs/printReceipt'
import { setLoginModalOpened } from './../../users/actions/users.actions'
import { setCartModalOpenedState } from './../../menu/menu.actions'
import { getRegisteredUserDiscounts } from './../../registered_user_discounts/actions/registered_user_discounts.actions'
import { getAccumulatedOrderAmountSetting } from './../../accumulated_order_amount_setting/actions/accumulated_order_amount_setting.actions'

import store from '../../store';
import { uniq } from 'lodash';
import { cartStorage } from '../../utils/fromLinkMode';

ReactPixel.init('2912758035505954');

// True when this order still has to be paid online, and the place wants the conversion counted
// only after the money lands (client_purchase_track_after_payment, default on).
const isAwaitingOnlinePayment = (paymentMethod) => {
    if (!paymentMethod) return false;

    const pm = String(paymentMethod);
    if (pm.indexOf('online') === -1 && pm !== 'epay') return false;

    return Utils.getSetting('client_purchase_track_after_payment') != '0';
};

// The trackers want an ISO code; the places only store a display suffix ("€", "лв.").
const getTrackingCurrency = () => {
    const suffix = String(Utils.getSetting('default_currency_suffix') || '€').toLowerCase();
    return (suffix.indexOf('лв') !== -1 || suffix.indexOf('bgn') !== -1) ? 'BGN' : 'EUR';
};

// Fires the client's own purchase/conversion trackers on a successful order.
// Each tracker is per-place and independent (empty setting = off):
//   - google_ads_conversion_id : Google Ads conversion (AW-XXX[/label]) or GA4 (G-XXX)
//   - client_ga4_id            : client's own Google Analytics 4 (G-XXX) purchase event
//   - client_facebook_pixel_id : client's own Meta/Facebook pixel Purchase event
// tabl's own global FB pixel (2912758035505954) is fired separately at each call site.
const trackClientPurchase = (totalPrice, transactionId, paymentMethod = null) => {
    // A card order is not a sale until the bank confirms it. With
    // `client_purchase_track_after_payment` on (the default) those orders report their Purchase
    // from PaymentProcessingPage instead, the moment the payment actually lands - so an abandoned
    // payment never counts as a conversion. Set the setting to 0 for the old behaviour.
    if (isAwaitingOnlinePayment(paymentMethod)) {
        console.log('[Client Tracking] Purchase deferred until the payment succeeds');
        return;
    }

    const value = totalPrice;
    const currency = getTrackingCurrency();

    // 1) Google Ads conversion / single Google tag (existing behaviour).
    const googleAdsConversionId = Utils.getSetting('google_ads_conversion_id');
    console.log('[Client Tracking] google_ads_conversion_id:', googleAdsConversionId, '| gtag:', typeof window.gtag !== 'undefined');
    if (googleAdsConversionId && typeof window.gtag !== 'undefined') {
        // GA4 tags (G-XXXX) use the standard `purchase` ecommerce event, while
        // Google Ads tags (AW-XXXX or AW-XXXX/label) use a `conversion` event.
        const isGa4 = String(googleAdsConversionId).indexOf('G-') === 0;
        const eventName = isGa4 ? 'purchase' : 'conversion';
        // Google Ads shows the conversion id and label separated by a comma
        // (AW-123,label), but gtag expects a slash for the send_to target
        // (AW-123/label). Normalise so either format entered in admin works.
        const sendTo = String(googleAdsConversionId).replace(/\s+/g, '').replace(',', '/');
        window.gtag('event', eventName, {
            'send_to': sendTo,
            'value': value,
            'currency': currency,
            'transaction_id': transactionId
        });
        console.log('[Client Tracking] OK Google Ads/GA', eventName, 'sent to', sendTo);
    }

    // 2) Client's own GA4 measurement id (separate from the Ads tag above, so a
    //    place can run BOTH Google Ads and Google Analytics at the same time).
    const clientGa4Id = Utils.getSetting('client_ga4_id');
    if (clientGa4Id && typeof window.gtag !== 'undefined') {
        const ga4Id = String(clientGa4Id).replace(/\s+/g, '');
        window.gtag('event', 'purchase', {
            'send_to': ga4Id,
            'value': value,
            'currency': currency,
            'transaction_id': transactionId
        });
        console.log('[Client Tracking] OK GA4 purchase sent to', ga4Id);
    }

    // 3) Client's own Meta/Facebook pixel. Base fbq lib is loaded in index.html;
    //    trackSingle targets ONLY the client's pixel so tabl's global pixel is
    //    unaffected. The pixel is init'd once in App.js (configureClientTrackers).
    const clientFbPixelId = Utils.getSetting('client_facebook_pixel_id');
    if (clientFbPixelId && typeof window.fbq === 'function') {
        const fbId = String(clientFbPixelId).replace(/\s+/g, '');
        const fbPayload = { currency: currency, value: value, order_id: transactionId };

        // eventID = the order number. The server sends the very same Purchase through the Meta
        // Conversions API with this id, and Meta keeps exactly one of the two (deduplication).
        if (transactionId) {
            window.fbq('trackSingle', fbId, 'Purchase', fbPayload, { eventID: transactionId });
        } else {
            window.fbq('trackSingle', fbId, 'Purchase', fbPayload);
        }
        console.log('[Client Tracking] OK Facebook pixel Purchase sent to', fbId, '| eventID:', transactionId);
    }
};

// Backwards-compatible alias for the older name used across order flows.
const trackGoogleAdsConversion = trackClientPurchase;

/**
 * The same trackers, fired the moment a card payment actually succeeds (PaymentProcessingPage).
 *
 * The customer comes back from the bank with a full page load, so the place settings can still be
 * in flight when the payment-result handler runs - wait for them (max ~10s) instead of silently
 * losing the conversion. No paymentMethod is passed on purpose: nothing is left to defer here.
 */
export const trackClientPurchaseAfterPayment = (totalPrice, transactionId, tries = 0) => {
    const state = store.getState();
    const settingsLoaded = !!(state && state.settings && state.settings.settings
        && Object.keys(state.settings.settings).length > 0);

    if (!settingsLoaded && tries < 20) {
        setTimeout(() => trackClientPurchaseAfterPayment(totalPrice, transactionId, tries + 1), 500);
        return;
    }

    trackClientPurchase(totalPrice, transactionId);
};

export const getProductIngredients = () => dispatch => {
    axios
        .get(API_URL + 'ingredients')
        .then(res => {
            dispatch({
                type: LIST_INGREDIENTS,
                payload: res.data
            });
        })
        .catch(error => {
            throw (error);
        });

    // Конфигурируемите групи добавки идват заедно със съставките, за да не се пипат
    // трите места, които зареждат менюто (initials.js x2 и ChoosePlaceModal).
    // Речник по groupId; продукт без групи просто няма запис тук.
    axios
        .get(API_URL + 'ingredient_groups')
        .then(res => {
            dispatch({
                type: LIST_INGREDIENT_GROUPS,
                payload: res.data || {}
            });
        })
        .catch(() => {
            // Групите са допълнение - ако заявката падне, менюто работи без тях.
        });
}

export const getAllProductsIfOnePlace = () => dispatch => {
    // if (showLoading) {
    dispatch({ type: LOADING_START });
    // }

    let url = 'productsOnePlace';

    axios.get(API_URL + url)
        .then(res => {
            dispatch({
                type: GET_ALL_PRODUCTS,
                payload: res.data
            });
            // if (showLoading) {
            dispatch({ type: LOADING_END });
            // }
        });
}

export const getProductsBySubcat = (subcat_id) => dispatch => {
    dispatch({ type: LOADING_START });

    axios
        .get(API_URL + 'subcategories/' + subcat_id)
        .then(res => {
            dispatch({
                type: GET_PRODUCTS_BY_SUBCAT,
                payload: res.data
            });
            dispatch({ type: LOADING_END });
        });
}

export const getProductsToOrder = () => dispatch => {
    dispatch({
        type: ADD_TO_CART,
        payload: getLocalCart()
    });
}

export const addProductTooltip = (id, name) => dispatch => {
    dispatch({
        type: ADD_PRODUCT_TOOLTIP,
        payload: { id: id, name: name }
    })
}

export const setOrderComment = (comments) => dispatch => {
    dispatch({
        type: SET_ORDER_COMMENT,
        payload: comments
    })
}

export const upsellProducts = (product, parentCartItemUuid = null) => dispatch => {
    if (product.related_products.length > 0) {
        dispatch(setUpsellingProductsModalOpened(true, product, parentCartItemUuid));
    }
}

export const setUpsellingProductsModalOpened = (state, product, parentCartItemUuid = null) => dispatch => {
    dispatch({
        type: SET_UPSELLING_PRODUCTS_MODAL_OPENED,
        payload: {
            modalOpened: state,
            productToUpsell: product,
            parentCartItemUuid: parentCartItemUuid
        }
    })
}

export const addToCart = (product_id, product_variant_id, product, selectedIngredients, category_id = null, forceNewLine = false) => dispatch => {
    // console.log("ADD TO CART");
    let catId = category_id || product.catHierarchyIds[0];
    let addedUuid = addToCartLocal(product_id, product_variant_id, false, product, selectedIngredients, catId, forceNewLine);

    // dispatch(updateRemoteCart());

    dispatch(upsellProducts(product, addedUuid));

    dispatch({
        type: ADD_TO_CART,
        payload: getLocalCart()
    })

    return addedUuid;
}

// Generates a UUID for cart line items. Used to reference a parent cart line when attaching
// related-products-as-addons; uses crypto.randomUUID where available, falls back otherwise.
const generateCartItemUuid = () => {
    try {
        if (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function') {
            return window.crypto.randomUUID();
        }
    } catch (e) { /* fall through */ }
    return 'ci-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
}

// Adds an entry into the parent cart item's addable_products[]. Always pushes a new row
// (no qty merging) per product spec. variantInfo: { product_variant_id, size, price, additional_price }.
export const addRelatedProductAsAddon = (parentCartItemUuid, relatedProduct, variantInfo) => dispatch => {
    if (!parentCartItemUuid || !relatedProduct || !variantInfo || !variantInfo.product_variant_id) return;

    let to_order = cartStorage().getItem('to_order');
    if (!to_order) return;
    to_order = JSON.parse(to_order);

    let found = false;
    Object.keys(to_order).forEach(pvKey => {
        if (!Array.isArray(to_order[pvKey])) return;
        to_order[pvKey].forEach(item => {
            if (item && item.cart_item_uuid === parentCartItemUuid) {
                if (!Array.isArray(item.addable_products)) item.addable_products = [];
                item.addable_products.push({
                    uuid: generateCartItemUuid(),
                    product_id: relatedProduct.id,
                    product_variant_id: variantInfo.product_variant_id,
                    name: relatedProduct.name,
                    product_translations: relatedProduct.translations || '',
                    variant_translations: variantInfo.translations || '',
                    size: variantInfo.size || '',
                    price: variantInfo.price,
                    additional_price: variantInfo.additional_price || 0,
                    qty: 1,
                });
                found = true;
            }
        });
    });

    if (!found) return;
    cartStorage().setItem('to_order', JSON.stringify(to_order));
    dispatch({ type: ADD_TO_CART, payload: getLocalCart() });
}

export const removeRelatedAddon = (parentCartItemUuid, addonUuid) => dispatch => {
    if (!parentCartItemUuid || !addonUuid) return;
    let to_order = cartStorage().getItem('to_order');
    if (!to_order) return;
    to_order = JSON.parse(to_order);

    Object.keys(to_order).forEach(pvKey => {
        if (!Array.isArray(to_order[pvKey])) return;
        to_order[pvKey].forEach(item => {
            if (item && item.cart_item_uuid === parentCartItemUuid && Array.isArray(item.addable_products)) {
                item.addable_products = item.addable_products.filter(a => a && a.uuid !== addonUuid);
            }
        });
    });

    cartStorage().setItem('to_order', JSON.stringify(to_order));
    dispatch({ type: ADD_TO_CART, payload: getLocalCart() });
}

export const removeProductFromCart = (product = null, prodIds = []) => dispatch => {
    // prodIds - MUST BE ARRAY | if prodIds passed - ingredients does NOT matter
    var to_order = cartStorage().getItem('to_order');//setItem('token', token)
    // console.log("REMOVE TO CART");

    if (!to_order) {
        to_order = {};
    } else {
        to_order = JSON.parse(to_order);
    }

    if (!to_order) {
        return null;
    }

    if (product == null && Object.values(prodIds).length > 0) {
        Object.values(to_order).map(pvs =>
            pvs.filter(p => prodIds.includes(p.product_id)).map(pp => {
                if (to_order[pp.product_variant_id]) {
                    delete to_order[pp.product_variant_id];
                }
            })
        )
    } else {

        let { product_variant_id, ingredients } = product;

        if (product_variant_id) {
            if (to_order && to_order[product_variant_id] && to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]) {
                // console.log('to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]', to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)])
                delete to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)];
                to_order[product_variant_id].splice(getUpdatableIndex(product_variant_id, ingredients), 1)
            }
        } else {
            // if (!product_variant_id && product.product_variants && product.product_variants[0] && product.product_variants[0].id) {
            //     product_variant_id = product.product_variants[0].id;
            // }

            if (product.product_variants && product.product_variants.length > 0) {

                product.product_variants.map(pv => {
                    if (pv.id && to_order[pv.id]) {
                        product_variant_id = pv.id;
                        if (to_order && to_order[product_variant_id] && to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]) {
                            // console.log('to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]', to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)])
                            delete to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)];
                            to_order[product_variant_id].splice(getUpdatableIndex(product_variant_id, ingredients), 1)
                        }
                    }
                })
            }
        }

    }

    // if (!product_variant_id && prodVariantId) {
    //     product_variant_id = prodVariantId;
    // }


    // if (to_order && to_order[product_variant_id] && to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]) {
    //     delete to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)];
    //     to_order[product_variant_id].splice(getUpdatableIndex(product_variant_id, ingredients), 1)
    // }


    // delete to_order[product_variant_id];

    cartStorage().setItem('to_order', JSON.stringify(to_order))

    // dispatch(updateRemoteCart());

    dispatch({
        type: ADD_TO_CART,
        payload: getLocalCart()
    })

}

export const updateProductQuantity = (product, quantity) => dispatch => {
    var to_order = cartStorage().getItem('to_order');//setItem('token', token)

    // debugger
    if (!to_order) {
        to_order = {};
    } else {
        to_order = JSON.parse(to_order);
    }

    const { product_variant_id, ingredients } = product;

    if (to_order && to_order[product_variant_id] && to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)] && to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]['quantity']) {
        to_order[product_variant_id][getUpdatableIndex(product_variant_id, ingredients)]['quantity'] = quantity;
    }

    // if (to_order[product_variant_id]['quantity']) {
    //     to_order[product_variant_id]['quantity'] = quantity;
    // }
    cartStorage().setItem('to_order', JSON.stringify(to_order))

    // dispatch(updateRemoteCart());

    dispatch({
        type: ADD_TO_CART,
        payload: getLocalCart()
    })
}

// export const getCartProductQuantity = (selectedIngredients) => {
//     var to_order = window.localStorage.getItem('to_order');//setItem('token', token)
//     to_order = JSON.parse(to_order);

//     let cartProductQuantity = 0;
//     if (to_order && Object.values(to_order).length > 0) {
//         Object.values(to_order).map(o => {
//             if (o.findIndex(i => parseInt(i.ingredients.required) == parseInt(selectedIngredients.required) && (isEqual(sortBy(i.ingredients.addable), sortBy(selectedIngredients.addable)) && (isEqual(sortBy(i.ingredients.removable), sortBy(selectedIngredients.removable))))) > -1) {
//                 cartProductQuantity = o.quantity
//             }
//         })
//     }
//     return cartProductQuantity;

// } 

// const differentIngridients = (product_variant_id, selectedIngredients) => {
//     var to_order = window.localStorage.getItem('to_order');//setItem('token', token)
//     to_order = JSON.parse(to_order);


//     let equalIngridients = false;
//     if (to_order && Object.values(to_order).length > 0) {
//         Object.values(to_order).map(o => {
//             equalIngridients = equalIngridients || (o.findIndex(i => parseInt(i.ingredients.required) == parseInt(selectedIngredients.required) && (isEqual(sortBy(i.ingredients.addable), sortBy(selectedIngredients.addable)) && (isEqual(sortBy(i.ingredients.removable), sortBy(selectedIngredients.removable))))) > -1)
//         })
//     }
//     return !equalIngridients;

// }

// Coerce missing required/addable/removable to defaults so items added without
// ingredient selections (e.g. quick-add from the related-products list on the
// view-product page) can still be matched by the cart for removal/quantity updates.
const normalizeIngredients = (ing) => ({
    required: ing && ing.required ? parseInt(ing.required) : 0,
    required2: ing && ing.required2 ? parseInt(ing.required2) : 0,
    addable: (ing && ing.addable) || [],
    removable: (ing && ing.removable) || [],
    // Отпечатък на избраните конфигурируеми групи - празен стринг за редове без групи,
    // така че старите редове в количката се сравняват точно както преди.
    groupsSignature: Utils.getGroupsSignature(ing && ing.groups),
});

// skipLine (optional): (line) => true to ignore a line, e.g. lines with a comment when merging a new add.
const getUpdatableIndex = (product_variant_id, selectedIngredients, skipLine = null) => {
    var to_order = cartStorage().getItem('to_order');//setItem('token', token)
    to_order = JSON.parse(to_order);

    const target = normalizeIngredients(selectedIngredients);

    let updateIndex = -1;
    if (to_order && Object.values(to_order).length > 0) {
        Object.values(to_order).map(o => {
            updateIndex = updateIndex == -1 ? (o.findIndex(i => {
                if (i.product_variant_id != product_variant_id) return false;
                if (skipLine && skipLine(i)) return false;
                const cur = normalizeIngredients(i.ingredients);
                return cur.required === target.required
                    && cur.required2 === target.required2
                    && isEqual(sortBy(cur.addable), sortBy(target.addable))
                    && isEqual(sortBy(cur.removable), sortBy(target.removable))
                    && cur.groupsSignature === target.groupsSignature;
            })) : updateIndex
        })
    }

    return updateIndex;
}



// 
// static differentIngridients(product_variant_id, selectedIngredients) {
//     // console.log('product_variant_id', product_variant_id)
//     // console.log('selectedIngredients', selectedIngredients)
//     var to_order = window.localStorage.getItem('to_order');//setItem('token', token)
//     to_order = JSON.parse(to_order);

//     let differentIngridients = false;
//     if (to_order && Object.values(to_order).length > 0) {
//         // console.log('to_order', to_order)
//         Object.values(to_order).map(o => {
//             // console.log('real o', o)

//             // console.log('o.length', o.length)
//             // console.log('o.filter(op=>op.product_variant_id == product_variant_id', o.filter(op => op.product_variant_id == product_variant_id));

//             if (o.filter(op => op.product_variant_id == product_variant_id).length == 1) {
//                 // console.log('1 e')
//                 // console.log('o[0]', o[0])
//                 // console.log('o[0].ingredients', o[0].ingredients)
//                 // console.log('parseInt(o[0].product_variant_id) == parseInt(product_variant_id', parseInt(o[0].product_variant_id) == parseInt(product_variant_id));
//                 // console.log('parseInt(o[0].ingredients.required) == parseInt(selectedIngredients.required)', parseInt(o[0].ingredients.required) == parseInt(selectedIngredients.required))
//                 // console.log('isEqual(sortBy(o[0].ingredients.addable), sortBy(selectedIngredients.addable))', isEqual(sortBy(o[0].ingredients.addable), sortBy(selectedIngredients.addable)))
//                 // console.log('isEqual(sortBy(o[0].ingredients.removable), sortBy(selectedIngredients.removable))', isEqual(sortBy(o[0].ingredients.removable), sortBy(selectedIngredients.removable)))

//                 if (parseInt(o[0].product_variant_id) == parseInt(product_variant_id)
//                     &&

//                     (Object.values(o[0].ingredients).length == 0 ||
//                         (parseInt(o[0].ingredients.required) == parseInt(selectedIngredients.required)
//                             && (isEqual(sortBy(o[0].ingredients.addable), sortBy(selectedIngredients.addable)))
//                             && (isEqual(sortBy(o[0].ingredients.removable), sortBy(selectedIngredients.removable)))
//                         )
//                     )
//                 ) {

//                     differentIngridients = true;
//                     // console.log('imago 1')
//                 }

//             } else if (o.filter(op => op.product_variant_id == product_variant_id).length > 1) {
//                 // console.log('nee 1')
//                 Object.values(o).map(oo => {
//                     if (parseInt(oo.product_variant_id) == parseInt(product_variant_id)
//                         && parseInt(oo.ingredients.required) == parseInt(selectedIngredients.required)
//                         && (isEqual(sortBy(oo.ingredients.addable), sortBy(selectedIngredients.addable)))
//                         && (isEqual(sortBy(oo.ingredients.removable), sortBy(selectedIngredients.removable)))
//                     ) {

//                         differentIngridients = true;
//                         // console.log('imago 2')
//                     }
//                 })
//             }

//         })
//     }
//     // console.log('razlichen li e :', !differentIngridients)
//     return !differentIngridients;

// }
// 


export const addToCartLocal = (product_id, product_variant_id, quantity, product, selectedIngredients = {}, category_id = null, forceNewLine = false) => {

    var to_order = cartStorage().getItem('to_order');//setItem('token', token)
    // debugger
    if (!to_order) {
        to_order = {};
    } else {
        to_order = JSON.parse(to_order);
    }

    if (selectedIngredients.required) {
        selectedIngredients.required = selectedIngredients.required;
    }

    let affectedUuid = null;

    let createNewLine = forceNewLine || !to_order[product_variant_id] || (to_order[product_variant_id] && Utils.differentIngridients(product_variant_id, selectedIngredients));

    // Never merge into a cart line that already has a comment — commented items are treated as distinct things and kept on separate lines.
    // Merge into the first matching line WITHOUT a comment; only when there is none, create a new line.
    let commentedUuids = [];
    try {
        let allComments = (store.getState().products && store.getState().products.order_comment) || [];
        commentedUuids = allComments.filter(c => c.cart_item_uuid && c.comment && c.comment.length > 0).map(c => c.cart_item_uuid);
    } catch (e) { /* ignore - fall back to normal merge */ }
    const isCommentedLine = (line) => !!(line && line.cart_item_uuid && commentedUuids.indexOf(line.cart_item_uuid) !== -1);

    let mergeIdx = -1;
    if (!createNewLine) {
        mergeIdx = getUpdatableIndex(product_variant_id, selectedIngredients, isCommentedLine);
        if (mergeIdx === -1) {
            createNewLine = true;
        }
    }

    if (createNewLine) {
        let selectedProdVariant = product['product_variants'].filter(pv => pv.id === product_variant_id)[0];
        // console.log('selectedProdVariant', selectedProdVariant)
        let toOrderProd = {};
        if (!to_order[product_variant_id]) {
            to_order[product_variant_id] = [];
        }

        let newUuid = (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function')
            ? window.crypto.randomUUID()
            : 'ci-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);

        toOrderProd['cart_item_uuid'] = newUuid;
        toOrderProd['addable_products'] = [];
        toOrderProd['product_variant_id'] = product_variant_id;
        toOrderProd['product_id'] = product_id;
        toOrderProd['size'] = selectedProdVariant['size'];
        toOrderProd['price'] = selectedProdVariant['price'];
        toOrderProd['additional_price'] = selectedProdVariant['additional_price'];
        // Base nutrition for this line = product value + variant value (additive).
        const baseNutrition = Utils.getBaseNutrition(product, selectedProdVariant);
        toOrderProd['kcal'] = baseNutrition.kcal;
        toOrderProd['protein'] = baseNutrition.protein;
        toOrderProd['carbs'] = baseNutrition.carbs;
        toOrderProd['fat'] = baseNutrition.fat;
        toOrderProd['name'] = product['name'];
        toOrderProd['image'] = product['product_images'] && product['product_images'][0] && product['product_images'][0].path ? Utils.getProductImagePath(product['product_images'][0].path, 1) : DEFAULT_PRODUCT_IMAGE;
        toOrderProd['date_added'] = new Date().getTime();
        toOrderProd['product_translations'] = product.translations || '';
        toOrderProd['variant_translations'] = selectedProdVariant.translations || '';
        toOrderProd['product_ingredients'] = product.product_ingredients || '';
        toOrderProd['ingredients'] = selectedIngredients || '';
        toOrderProd['quantity'] = 1;
        toOrderProd['catHierarchyId'] = category_id;
        // Собствена опаковка на продукта (ако е зададена) - печели пред тази на категорията при показване.
        toOrderProd['packaging'] = product.packaging || null;
        toOrderProd['discount_percent'] = product.discount_percent;
        toOrderProd['discount_money'] = product.discount_money;

        toOrderProd['time_based_discount_enabled'] = product.time_based_discount_enabled;
        toOrderProd['time_based_discount_percent'] = product.time_based_discount_percent;
        toOrderProd['time_based_discount_start_hour'] = product.time_based_discount_start_hour;
        toOrderProd['time_based_discount_end_hour'] = product.time_based_discount_end_hour;
        toOrderProd['time_based_discount_days'] = product.time_based_discount_days;
        toOrderProd['disable_promocode_discount'] = product.disable_promocode_discount;

        to_order[product_variant_id].push(toOrderProd);
        affectedUuid = newUuid;

    } else {

        let existingIdx = mergeIdx;
        if (!quantity) {
            if (to_order[product_variant_id] && to_order[product_variant_id][existingIdx] && to_order[product_variant_id][existingIdx]['quantity']) {
                to_order[product_variant_id][existingIdx]['quantity'] += 1;
            }
        } else {
            to_order[product_variant_id][existingIdx]['quantity'] = quantity;
        }
        if (to_order[product_variant_id] && to_order[product_variant_id][existingIdx]) {
            // Backfill uuid for legacy items so they can be referenced by the upselling flow.
            if (!to_order[product_variant_id][existingIdx].cart_item_uuid) {
                to_order[product_variant_id][existingIdx].cart_item_uuid =
                    (typeof window !== 'undefined' && window.crypto && typeof window.crypto.randomUUID === 'function')
                        ? window.crypto.randomUUID()
                        : 'ci-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
            }
            if (!Array.isArray(to_order[product_variant_id][existingIdx].addable_products)) {
                to_order[product_variant_id][existingIdx].addable_products = [];
            }
            affectedUuid = to_order[product_variant_id][existingIdx].cart_item_uuid;
        }
    }


    cartStorage().setItem('to_order', JSON.stringify(to_order))
    return affectedUuid;
}

export const getLocalCart = function () {
    var to_order = cartStorage().getItem('to_order');
    if (!to_order) {
        to_order = [];
    } else {
        to_order = JSON.parse(to_order);
    }

    let sortedOrders = to_order;
    // sortedOrders = _.sortBy(sortedOrders, [function(o) { return o.date_added; }])
    sortedOrders = sortBy(sortedOrders, ['date_added'])
    return sortedOrders;

    // return to_order;
}

export const clearCartLocal = () => dispatch => {
    cartStorage().removeItem('to_order');
    dispatch({ type: CLEAR_CART })// clear cart from state 

    removeCartIdLocal(); // clear cart uuid from cookies
}


const makeOrderCatcher = (error, msg = '') => dispatch => {
    let translations = store.getState().lang.translations;

    // Safety net: server may still return phone_not_verified due to a race or expired DB record
    if (error && error.response && error.response.data && error.response.data.error_key === 'phone_not_verified') {
        dispatch(addErrorMessages([translations && translations.messages && translations.messages.errors && translations.messages.errors.phone_not_verified || "Моля потвърдете телефонния си номер чрез SMS код."]));
        return;
    }

    if (error && error.response && error.response.data && error.response.data && error.response.data.payload) {

        let inactiveProductIngredientsIds = error.response.data.payload.inactiveProductIngredientsIds;
        let inactiveProductsIds = error.response.data.payload.inactiveProductsIds;
        let noProductsToInsert = error.response.data.payload.noProductsToInsert;

        if (inactiveProductIngredientsIds && Object.values(inactiveProductIngredientsIds).length > 0) {
            inactiveProductIngredientsIds = uniq(inactiveProductIngredientsIds)

            let allProducts = store.getState().products.all_products;

            let inactiveProductNames = '';
            (inactiveProductIngredientsIds).map((pId, k) => {
                inactiveProductNames = inactiveProductNames + ((inactiveProductIngredientsIds.length - 2 != k && k != 0) ? " и " : '') + "'" + (allProducts && allProducts[pId] && allProducts[pId].name || "") + "'" + (inactiveProductIngredientsIds.length - 2 > k ? ", " : '');
            })

            dispatch(removeProductFromCart(null, inactiveProductIngredientsIds))
            dispatch({
                type: ORDER_FAILED,
                payload: { message: `Продуктите: '${inactiveProductNames}' съдържат съставки, които вече не са налични. За да поръчате без тези продукти натиснете отново Поръчай или обновете страницата и добавете други съставки към продуктите.` }
            })
            dispatch(addErrorMessages(["Възникна грешка"]));
        } else if (inactiveProductsIds && Object.values(inactiveProductsIds).length > 0) {
            let allProducts = store.getState().products.all_products;

            let inactiveProductNames = '';
            (inactiveProductsIds).map((pId, k) => {
                inactiveProductNames = inactiveProductNames + ((inactiveProductsIds.length - 2 != k && k != 0) ? " и " : '') + "'" + (allProducts && allProducts[pId] && allProducts[pId].name || "") + "'" + (inactiveProductsIds.length - 2 > k ? ", " : '');
            })

            dispatch(removeProductFromCart(null, inactiveProductsIds))
            dispatch({
                type: ORDER_FAILED,
                payload: { message: `Продуктите: '${inactiveProductNames}' вече не са налични, за да поръчате без тях натиснете отново Поръчай или обновете страницата и добавете други продукти в количката.` }
            })
            dispatch(addErrorMessages(["Възникна грешка"]));
        }
        else if (error.response.data.payload.message && error.response.data.payload.message == "invalid_products_for_place") {
            dispatch(clearCartLocal());
            dispatch(setErrorAndReloadModalMessage(translations && translations.messages.errors.invalid_products_for_place || "Опитвате да поръчате продукти от друг обект. Страницата ще бъде презаредена. Моля поръчайте отново. Извиняваме се за неудобството :)"))
        } else if (error.response.data.payload.message && error.response.data.payload.message == "place_not_active") {
            // Старият (изтрит/спрян) обект от кукито или от кеширана страница - презареждаме за актуалното меню.
            dispatch(clearCartLocal());
            dispatch(setErrorAndReloadModalMessage(translations && translations.messages.errors.place_not_active || "Менюто е обновено. Страницата ще бъде презаредена. Моля поръчайте отново. Извиняваме се за неудобството :)"))
        } else if (error.response.data.payload.message && error.response.data.payload.message == "orders_not_allowed") {

            dispatch(addErrorMessages([translations && translations.messages.errors.orders_not_allowed || "В момента не приемаме поръчки. Моля опитайте по-късно."]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == "order_type_not_available") {

            dispatch(addErrorMessages([translations && translations.messages.errors.order_type_not_available || "В момента не приемаме поръчки от този тип. Моля опитайте по-късно."]));

        } else if (error.response.data.payload.message && noProductsToInsert) {
            dispatch(addErrorMessages(["Няма продукти в количката, моля добавете и след това опитайте да поръчате"]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == "card_payment_requires_login") {
            dispatch(addErrorMessages(["За да платите онлайн трябва да сте влезли в акаунта си"]));
            dispatch(setLoginModalOpened(true));
        } else if (error.response.data.payload.message && error.response.data.payload.message == "min_order_price_for_radius_not_fulfilled") {
            let msg = error.response.data.payload.message_trans ? error.response.data.payload.message_trans : "Моля добавете още продукти в количката"
            dispatch(addErrorMessages([msg]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == 'anon_user_banned') {
            let msg = error.response.data.payload.message_trans ? error.response.data.payload.message_trans : "Не може да пускате повече поръчки."
            dispatch(addErrorMessages([msg]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == 'invalid_delivery_shape') {
            let msg = translations && translations.messages.errors.invalid_delivery_shape || "Моля проверете адреса за доставка или го въведете отново"
            dispatch(addErrorMessages([msg]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == 'invalid_region_for_place') {
            let msg = translations && translations.messages.errors.invalid_region_for_place || "Моля проверете региона за доставка или го изберете отново"
            dispatch(addErrorMessages([msg]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == 'too_mony_orders_for_session_in_x_seconds') {
            let msg = translations && translations.messages.errors.too_mony_orders_for_session_in_x_seconds || "Опитвате се да изпратите една и съща поръчка повече от веднъж. Моля опитайте отново след няколко секунди"
            dispatch(addErrorMessages([msg]));
        } else if (error.response.data.payload.message && error.response.data.payload.message == 'room_qr_scan_required') {
            let msg = translations && translations.messages.errors.please_scan_qr_code_to_order || "Моля, сканирайте QR кода, за да поръчате."
            dispatch({ type: ORDER_FAILED, payload: { message: msg } });
            dispatch(addErrorMessages([msg]));
        } else {
            dispatch(addErrorMessages([msg ? msg : (translations && translations.messages.errors.please_try_again || "Моля опитайте отново!!")]));
        }
    }
    else {
        dispatch({
            type: ORDER_FAILED,
            payload: { message: translations && translations.messages.errors.error_sending_order || "Възникна грешка при изпращане на поръчката!" } //No translation needed
        })
        dispatch(addErrorMessages([msg ? msg : (translations && translations.messages.errors.please_try_again || "Моля опитайте отново")]));
    }
}

export const makeOrder = (orderData, orderComment, orderType = 2, translations) => dispatch => {
    if (orderData && (orderData.payment_method == "epay")) {
        if (!Auth.getAuthUserToken()) {
            dispatch(addErrorMessages(["За да платите онлайн трябва да сте влезли в акаунта си"]));
            dispatch(setLoginModalOpened(true));
            return;
        }
    }

    const pendingOrder = { orderData, orderComment, orderType, translations };

    // Geo-fence gate for dine-in ("spot" = 1) and hotel ("room" = 6) orders. When the
    // restriction is enabled (and an actual zone is drawn), open a modal that asks the
    // customer to allow location, re-checks it against the allowed zone, and submits the
    // order automatically once a location inside the zone is obtained. The server re-validates.
    if ((orderType == 1 || orderType == 6) && Utils.isOrderLocationRestricted() && Utils.getOrderLocationFencePolygon().length >= 3) {
        dispatch(openOrderLocationModal(pendingOrder));
        return;
    }

    dispatch(submitOrderResolved(pendingOrder, null));
}

// Actually routes a (possibly geo-resolved) order to the right per-type request. `coords`
// is { lat, lng } when the location gate produced a position, otherwise null.
export const submitOrderResolved = (pendingOrder, coords) => dispatch => {
    const { orderData, orderComment, orderType, translations } = pendingOrder;

    dispatch({ type: LOADING_ORDER_START });
    window.localStorage.removeItem('bill_wanted');

    if (window.location.hostname !== 'localhost'
        && window.location.hostname !== 'test.tabl.bg'
        && window.location.hostname !== 'gabrovo-pizza.tabl.bg'
    ) {
        ReactPixel.trackSingleCustom('2912758035505954', "PurchaseTry", { name: 'Name: ' + (orderData && orderData.name) + ' Phone: ' + (orderData && orderData.phone) + ' OrderType: ' + orderType }); // For tracking custom events.
    }

    let dataWithCoords = orderData;
    if (coords) {
        dataWithCoords = { ...(orderData || {}), order_lat: coords.lat, order_lng: coords.lng };
    }

    if (orderType == 1) {
        dispatch(sendRequestRestaurant(orderComment, translations, coords));
    } else if (orderType == 2) {
        dispatch(sendRequestDelivery(dataWithCoords, orderComment));
    } else if (orderType == 3) {
        dispatch(sendRequestPickup(dataWithCoords, orderComment));
    } else if (orderType == 6) {
        dispatch(sendRequestRoom(dataWithCoords, orderComment, translations));
    } else if (orderType == 7) {
        dispatch(sendRequestServedOnSpot(dataWithCoords, orderComment));
    }
}

// --- Order location modal (geo-fence for spot/room) ---

export const openOrderLocationModal = (pendingOrder) => dispatch => {
    dispatch({ type: SET_ORDER_LOCATION_MODAL, payload: { open: true, status: 'idle', pendingOrder } });
    // The modal is now the (blocking) gate, so the underlying "Order" button doesn't need to
    // stay disabled - re-enable it so it works again after the modal is closed.
    dispatch(setDisabledMakeOrderButton(false));
}

export const closeOrderLocationModal = () => dispatch => {
    dispatch({ type: SET_ORDER_LOCATION_MODAL, payload: { open: false, status: 'idle', pendingOrder: null } });
    dispatch(setDisabledMakeOrderButton(false));
}

// Triggered by the "Allow location" button. Requests the device location (re-prompts the
// browser each press, which recovers the "dismissed the prompt" case without a page reload),
// then either submits the stashed order (inside the zone) or updates the modal status.
export const requestOrderLocationAndSubmit = () => (dispatch, getState) => {
    const pendingOrder = getState().products.orderLocationPendingOrder;
    if (!pendingOrder) return;

    dispatch({ type: SET_ORDER_LOCATION_MODAL, payload: { status: 'locating' } });

    Utils.checkOrderLocation().then(result => {
        if (result.status === 'inside' || result.status === 'not_restricted') {
            dispatch({ type: SET_ORDER_LOCATION_MODAL, payload: { open: false, status: 'idle', pendingOrder: null } });
            dispatch(submitOrderResolved(pendingOrder, result.status === 'inside' ? { lat: result.lat, lng: result.lng } : null));
        } else {
            // 'outside' | 'denied' | 'unsupported'
            dispatch({ type: SET_ORDER_LOCATION_MODAL, payload: { status: result.status } });
        }
    });
}


// const sendSmsForNewOrder = (orderData, products, orderTypes, phoneNum) => {
//     const { name, phone, address, email, pickupDate, pickupTime } = orderData;

//     let pickupDateFormat = new Date(pickupDate + '.' + (new Date()).getFullYear());
//     pickupDateFormat = Auth.appendLeadingZeroes(pickupDateFormat.getDate()) + '.' + Auth.appendLeadingZeroes(parseInt(parseInt(pickupDateFormat.getMonth()) + 1));

//     let pickupTimeText = '';
//     if (orderTypes == 3) {
//         pickupTimeText = 'Shte%20vzeme%20v:%20' + pickupDateFormat + '%20' + pickupTime;
//     } else if (orderTypes == 2) {
//         pickupTimeText = 'Dostavi%20v:%20' + pickupDateFormat + '%20' + pickupTime;
//     }

//     let prods = '';
//     Object.values(products).map(p => {
//         prods += p.quantity + ' x ' + p.name + ' | ';
//     });

//     // DENIS PHONE axios.get(`https://platform.clickatell.com/messages/http/send?apiKey=q8ppKOM_Sy-gydxpYqKXvw==&to=359884014689&content=TabL.BG%20|%20Nova%20poruchka%20ot%20${name}:%20${prods}%20${pickupTimeText}`) //DENIS PHONE
//     axios.get(`https://platform.clickatell.com/messages/http/send?apiKey=q8ppKOM_Sy-gydxpYqKXvw==&to=${phoneNum}&content=TabL.BG%20|%20Nova%20poruchka%20ot%20${name}:%20${prods}%20${pickupTimeText}`)

// }

// const sendSmsForNewOrderDenis = (orderData, products, orderTypes) => {
//     const { name, phone, address, email, pickupDate, pickupTime } = orderData;

//     let pickupDateFormat = new Date(pickupDate + '.' + (new Date()).getFullYear());
//     pickupDateFormat = Auth.appendLeadingZeroes(pickupDateFormat.getDate()) + '.' + Auth.appendLeadingZeroes(parseInt(parseInt(pickupDateFormat.getMonth()) + 1));

//     let pickupTimeText = '';
//     if (orderTypes == 3) {
//         pickupTimeText = 'Shte%20vzeme%20v:%20' + pickupDateFormat + '%20' + pickupTime;
//     } else if (orderTypes == 2) {
//         pickupTimeText = 'Dostavi%20v:%20' + pickupDateFormat + '%20' + pickupTime;
//     }

//     let prods = '';
//     Object.values(products).map(p => {
//         prods += p.quantity + ' x ' + p.name + ' | ';
//     });

//     axios.get(`https://platform.clickatell.com/messages/http/send?apiKey=q8ppKOM_Sy-gydxpYqKXvw==&to=359884014689&content=TabL.BG%20|%20Nova%20poruchka%20ot%20${name}:%20${prods}%20${pickupTimeText}`) //DENIS PHONE

// }


const setOrderDate = (date, time) => {
    // Calculates year and returns the whole date mm.dd.yyyy hh:ii

    if (!(date && time && date.indexOf('.') != -1)) return '';
    if (time && time.indexOf(':') == -1) time = '';
    let splitedDate = date.split('.');
    let selectedOrderMonth = splitedDate[0];
    let selectedOrderDate = splitedDate[1];
    return date + '.' + Utils.getOrderDateYear(selectedOrderMonth, selectedOrderDate) + ' ' + time;
}

// Attach the per-line comment to each product before sending the order.
// Prefer the cart-line comment (matched by cart_item_uuid); fall back to a per-variant comment (set from the product page).
const attachLineComments = (productsArr, orderComment) => {
    if (!Array.isArray(orderComment) || orderComment.length === 0) return productsArr;
    return productsArr.map(p => {
        let c = orderComment.find(oc => oc.cart_item_uuid && p.cart_item_uuid && oc.cart_item_uuid === p.cart_item_uuid && oc.comment);
        if (!c) c = orderComment.find(oc => !oc.cart_item_uuid && oc.variantId == p.product_variant_id && oc.comment);
        return c ? { ...p, comment: c.comment } : p;
    });
}

const sendRequestDelivery = (data, orderComment) => dispatch => {
    const { name, phone, address, addressDetails, email, orderDate, orderTime, regionId, deliveryRadiusId, deliveryShapeId, payment_method, payment_instrument, cutlery, promoCode, promoCodeApplied, orderTextComment } = data;

    const userToken = Auth.getUserToken();
    var to_order = getLocalCart();

    let productsArrToSend = [];
    Object.values(to_order).map(t =>
        productsArrToSend = productsArrToSend.concat(t)
    );
    productsArrToSend = attachLineComments(productsArrToSend, orderComment);

    axios.post(API_URL + 'orders/delivery?t=' + ((new Date()).getTime()), {
        products: productsArrToSend,
        client_name: name,
        client_phone: phone,
        client_address: address + (addressDetails && addressDetails.length > 0 ? " / " + addressDetails : ""),
        street_number: data.streetNumber ?? null,
        floor_number: data.floorNumber ?? null,
        ap_number: data.apNumber ?? null,
        bell_number: data.bellNumber ?? null,
        entrance_number: data.entranceNumber ?? null,
        building_number: data.buildingNumber ?? null,
        delivery_postal_code: data.postalCode ?? null,
        client_email: email,
        token: userToken,
        order_comment: orderComment,
        delivery_time: setOrderDate(orderDate, orderTime),
        exact_time_selected: orderTime && orderTime.indexOf(':') == -1 ? 0 : 1,
        regionId: regionId,
        deliveryRadiusId: deliveryRadiusId,
        deliveryShapeId: deliveryShapeId,
        payment_method: payment_method,
        cutlery: cutlery,
        cartId: getCartIdLocal(),
        promo_code: promoCodeApplied ? promoCode : '',
        order_text_comment: orderTextComment,
        subscribe_for_lunch_menu: data.subscribe_for_lunch_menu,
        lat: data.lat,
        lng: data.lng,
        delivery_address_lat: data.delivery_address_lat,
        delivery_address_lng: data.delivery_address_lng,
        free_product: data.free_product,
        count_cutlery: data.count_cutlery,
        userDeviceData: Utils.getDeviceAndBrowserDetails(),
        accumulatedOrderAmountUsed: data.accumulatedOrderAmountUsed,
        tip_amount: data.tip_amount || 0,
        change_banknote_amount: data.need_change && data.change_banknote_amount ? data.change_banknote_amount : null
    }, { timeout: 55000 }) // Timeout 35 sec
        .then(res => {
            dispatch({
                type: ORDERED_SUCCESSFULLY,
                payload: { message: "Поръчката ви скоро ще бъде доставена.", token: res.data.token, current_order_type: 2, orderPaymentMethod: payment_method } //No translation needed
            })
            // Set token when delivery/preorder
            if (userToken == '' || !userToken) {
                Auth.setUserToken(res.data.token);
            }
            // Purchase pixel
            if (window.location.hostname !== 'localhost'
                && window.location.hostname !== 'test.tabl.bg'
                && window.location.hostname !== 'gabrovo-pizza.tabl.bg'
            ) {
                ReactPixel.trackSingleCustom('2912758035505954', "Purchase", { currency: "BGN", value: res.data.totalPrice.toFixed(2) }); // For tracking custom events.
            }

            // Google Ads conversion tracking
            trackGoogleAdsConversion(res.data.totalPrice, res.data.key, payment_method);

            dispatch(handleOnlinePayment(res.data.key, payment_method, payment_instrument, 'delivery', res.data));
            dispatch(getRegisteredUserDiscounts());
            dispatch(getAccumulatedOrderAmountSetting());

            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });

            dispatch({ type: LOADING_ORDER_END });

        }).catch(error => {
            dispatch(makeOrderCatcher(error));

            Auth.removeUserToken();

            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });

            dispatch({ type: LOADING_ORDER_END });
            // throw (error);
        });

}

const sendRequestPickup = (data, orderComment) => dispatch => {
    const { name, phone, address, email, orderDate, orderTime, payment_method, payment_instrument, cutlery, promoCode, promoCodeApplied, orderTextComment, count_cutlery } = data;
    const userToken = Auth.getUserToken();
    var to_order = getLocalCart();

    let productsArrToSend = [];
    Object.values(to_order).map(t =>
        productsArrToSend = productsArrToSend.concat(t)
    );
    productsArrToSend = attachLineComments(productsArrToSend, orderComment);
    axios.post(API_URL + 'orders/preorder', {
        products: productsArrToSend,
        client_name: name,
        client_phone: phone,
        // client_address: address, no need to send address on pickup order
        client_email: email,
        token: userToken,
        order_comment: orderComment,
        pickup_time: setOrderDate(orderDate, orderTime),
        exact_time_selected: orderTime && orderTime.indexOf(':') == -1 ? 0 : 1,
        payment_method: payment_method,
        cutlery: cutlery,
        promo_code: promoCodeApplied ? promoCode : '',
        order_text_comment: orderTextComment,
        subscribe_for_lunch_menu: data.subscribe_for_lunch_menu,
        free_product: data.free_product,
        pickupPlaceId: data.pickupPlaceId ? data.pickupPlaceId : null,
        count_cutlery: count_cutlery,
        accumulatedOrderAmountUsed: data.accumulatedOrderAmountUsed,
        tip_amount: data.tip_amount || 0,
        change_banknote_amount: data.need_change && data.change_banknote_amount ? data.change_banknote_amount : null
    }, { timeout: 55000 }) // Timeout 35 sec
        .then(res => {

            dispatch({
                type: ORDERED_SUCCESSFULLY,
                payload: { message: "Поръчката ви скоро ще бъде приготвена.", token: res.data.token, current_order_type: 3 } //No translation needed
            })

            // Set token when delivery/preorder
            if (userToken == '' || !userToken) {
                Auth.setUserToken(res.data.token);
            }

            // Purchase pixel
            if (window.location.hostname !== 'localhost'
                && window.location.hostname !== 'test.tabl.bg'
                && window.location.hostname !== 'gabrovo-pizza.tabl.bg'
            ) {
                ReactPixel.trackSingleCustom('2912758035505954', "Purchase", { currency: "BGN", value: res.data.totalPrice.toFixed(2) }); // For tracking custom events.
            }

            // Google Ads conversion tracking
            trackGoogleAdsConversion(res.data.totalPrice, res.data.key, payment_method);

            dispatch(handleOnlinePayment(res.data.key, payment_method, payment_instrument, 'pickup', res.data));

            dispatch(getRegisteredUserDiscounts());
            dispatch(getAccumulatedOrderAmountSetting());

            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });
            dispatch({ type: LOADING_ORDER_END });

        }).catch(error => {
            dispatch(makeOrderCatcher(error));
            Auth.removeUserToken();
            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });
            dispatch({ type: LOADING_ORDER_END });
            // throw (error);
        });

}

const sendRequestRoom = (data, orderComment, translations) => dispatch => {
    const { name, phone, address, email, orderDate, orderTime, room_number, payment_method, payment_instrument, cutlery, promoCode, promoCodeApplied, additional_order_type, orderTextComment } = data;
    const userToken = Auth.getUserToken();
    var to_order = getLocalCart();

    // console.log(" translations", translations && translations.messages.notifications && translations.messages.notifications.order_sent_success || "Поръчката ви скоро ще бъде сервирана.")
    let productsArrToSend = [];
    Object.values(to_order).map(t =>
        productsArrToSend = productsArrToSend.concat(t)
    );
    productsArrToSend = attachLineComments(productsArrToSend, orderComment);
    axios.post(API_URL + 'orders/room', {
        products: productsArrToSend,
        client_name: name,
        client_phone: phone,
        client_email: email,
        token: userToken,
        order_comment: orderComment,
        pickup_time: setOrderDate(orderDate, orderTime),
        exact_time_selected: orderTime && orderTime.indexOf(':') == -1 ? 0 : 1,
        room_number: Auth.getRoomNumInToken() ? Auth.getRoomNumInToken() : room_number ? room_number : '',
        payment_method: payment_method,
        cutlery: cutlery,
        cutlery: cutlery,
        promo_code: promoCodeApplied ? promoCode : '',
        additional_order_type: additional_order_type,
        order_text_comment: orderTextComment,
        accumulatedOrderAmountUsed: data.accumulatedOrderAmountUsed,
        tip_amount: data.tip_amount || 0,
        change_banknote_amount: data.need_change && data.change_banknote_amount ? data.change_banknote_amount : null,
        order_lat: data.order_lat || null,
        order_lng: data.order_lng || null
    }, { timeout: 55000 }) // Timeout 35 sec
        .then(res => {
            dispatch({
                type: ORDERED_SUCCESSFULLY,
                payload: {
                    message: translations && translations.messages.notifications && translations.messages.notifications.order_sent_success || "Поръчката ви скоро ще бъде сервирана.", // не взима тоя превод, а тоя в handleOnlinePayment
                    token: res.data.token,
                    current_order_type: 6
                }
            })

            // Set token when delivery/preorder
            if (userToken == '' || !userToken) {
                Auth.setUserToken(res.data.token);
            }

            // Purchase pixel
            if (window.location.hostname !== 'localhost'
                && window.location.hostname !== 'test.tabl.bg'
                && window.location.hostname !== 'gabrovo-pizza.tabl.bg'
            ) {
                ReactPixel.trackSingleCustom('2912758035505954', "Purchase", { currency: "BGN", value: res.data.totalPrice.toFixed(2) }); // For tracking custom events.
            }

            // Google Ads conversion tracking
            trackGoogleAdsConversion(res.data.totalPrice, res.data.key, payment_method);

            dispatch(handleOnlinePayment(res.data.key, payment_method, payment_instrument, 'room', res.data, translations));

            dispatch(getRegisteredUserDiscounts());
            dispatch(getAccumulatedOrderAmountSetting());
            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });

            dispatch({ type: LOADING_ORDER_END });

        }).catch(error => {
            dispatch(makeOrderCatcher(error));

            Auth.removeUserToken();
            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });

            dispatch({ type: LOADING_ORDER_END });
            // throw (error);
        });

}

const sendRequestRestaurant = (orderComment, stranslations, coords = null) => dispatch => {
    var to_order = getLocalCart();
    const userToken = Auth.getUserToken();

    // dispatch(setCurrOpenedModal( "multiple" ));
    let productsArrToSend = [];
    Object.values(to_order).map(t =>
        productsArrToSend = productsArrToSend.concat(t)
    );
    productsArrToSend = attachLineComments(productsArrToSend, orderComment);

    axios
        .post(API_URL + 'orders', {
            // table_token: userToken,
            session: userToken,
            products: productsArrToSend,
            order_comment: orderComment,
            order_lat: coords ? coords.lat : null,
            order_lng: coords ? coords.lng : null
        }, { timeout: 55000 }) // Timeout 35 sec
        .then(res => {

            // Purchase pixel
            if (window.location.hostname !== 'localhost'
                && window.location.hostname !== 'test.tabl.bg'
                && window.location.hostname !== 'gabrovo-pizza.tabl.bg'
            ) {
                ReactPixel.trackSingleCustom('2912758035505954', "Purchase", { currency: "BGN", value: res.data.totalPrice.toFixed(2) }); // For tracking custom events.
            }

            // Google Ads conversion tracking
            trackGoogleAdsConversion(res.data.totalPrice, res.data.key || '', res.data.paymentMethod || null);

            dispatch({
                type: ORDERED_SUCCESSFULLY,
                payload: { message: "Поръчката ви скоро ще бъде сервирана.", current_order_type: 1 } //No translation needed
            })

            let payment_method = res && res.data && res.data.paymentMethod || null;
            if (payment_method) {
                dispatch(handleOnlinePayment(null, payment_method, null, 'spot', res.data));
            }

            dispatch(addSuccessMessage("Поръчката ви скоро ще бъде сервирана"))

            dispatch(clearCartLocal());
            dispatch(getRegisteredUserDiscounts());

            dispatch({ type: LOADING_ORDER_END });
            dispatch(closeScanModal());
            dispatch(setCurrOpenedModal(''))

        }).catch(error => {
            if (window.localStorage.getItem('app')) {
                // history.push("/close-browser-app")
                window.location.pathname = "/close-browser-app"
            } else {

                // за бъг в beyond brkfst - по някаква причина се наспамват мн поръчки понякога и влизат при нас и в барси. Поръчка с едни и също продукти 5 пъти..
                if (error.response.data.payload.message && error.response.data.payload.message == 'too_mony_orders_for_session_in_x_seconds') {
                    let msg = 'Опитвате се да изпратите една и съща поръчка повече от веднъж. Моля опитайте отново след няколко секунди или проверете дали вече не сте поръчали успешно в менюто "Поръчки"';
                    dispatch(addErrorMessages([msg]));
                } else {
                    dispatch(openScanModal());

                    let msg = "";
                    if (Auth.getUserToken()) {
                        msg = "Моля сканирайте отново QR кода или такъв с активирана опция за поръчка";
                        dispatch(setOrderModalState(1));

                    } else {
                        msg = "Възникна грешка при изпращане на поръчката"
                    }

                    // dispatch({
                    //     type: ORDER_FAILED,
                    //     payload: { message: msg } //No translation needed
                    // });
                    dispatch(makeOrderCatcher(error, msg));

                }

                dispatch(setDisabledMakeOrderButton(false));

                // dispatch(closeScanModal());

                // Auth.removeUserToken();
                dispatch({ type: LOADING_ORDER_END });
            }
        });
}

const sendRequestServedOnSpot = (data, orderComment) => dispatch => {
    const { name, phone, address, email, orderDate, orderTime, payment_method, payment_instrument, cutlery, promoCode, promoCodeApplied, orderTextComment } = data;
    const userToken = Auth.getUserToken();
    var to_order = getLocalCart();

    let productsArrToSend = [];
    Object.values(to_order).map(t =>
        productsArrToSend = productsArrToSend.concat(t)
    );
    productsArrToSend = attachLineComments(productsArrToSend, orderComment);
    axios.post(API_URL + 'orders/served-on-spot', {
        products: productsArrToSend,
        client_name: name,
        client_phone: phone,
        client_address: address,
        client_email: email,
        token: userToken,
        order_comment: orderComment,
        pickup_time: setOrderDate(orderDate, orderTime),
        exact_time_selected: orderTime && orderTime.indexOf(':') == -1 ? 0 : 1,
        payment_method: payment_method,
        cutlery: cutlery,
        promo_code: promoCodeApplied ? promoCode : '',
        order_text_comment: orderTextComment,
        subscribe_for_lunch_menu: data.subscribe_for_lunch_menu,
        free_product: data.free_product,
        pickupPlaceId: data.pickupPlaceId ? data.pickupPlaceId : null,
        accumulatedOrderAmountUsed: data.accumulatedOrderAmountUsed
    }, { timeout: 55000 }) // Timeout 35 sec
        .then(res => {

            dispatch({
                type: ORDERED_SUCCESSFULLY,
                payload: { message: "Поръчката ви скоро ще бъде приготвена.", token: res.data.token, current_order_type: 3 } //No translation needed
            })

            // Set token when delivery/preorder
            if (userToken == '' || !userToken) {
                Auth.setUserToken(res.data.token);
            }

            // Purchase pixel
            if (window.location.hostname !== 'localhost'
                && window.location.hostname !== 'test.tabl.bg'
                && window.location.hostname !== 'gabrovo-pizza.tabl.bg'
            ) {
                ReactPixel.trackSingleCustom('2912758035505954', "Purchase", { currency: "BGN", value: res.data.totalPrice.toFixed(2) }); // For tracking custom events.
            }

            // Google Ads conversion tracking
            trackGoogleAdsConversion(res.data.totalPrice, res.data.key, payment_method);

            dispatch(handleOnlinePayment(res.data.key, payment_method, payment_instrument, 'pickup', res.data));
            dispatch(getRegisteredUserDiscounts());
            dispatch(getAccumulatedOrderAmountSetting());

            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });

            dispatch({ type: LOADING_ORDER_END });

        }).catch(error => {
            dispatch(makeOrderCatcher(error));

            Auth.removeUserToken();
            
            // Изчистваме промокода
            dispatch({ type: CLEAR_PROMOCODE });

            dispatch({ type: LOADING_ORDER_END });
            // throw (error);
        });

}

const handleOnlinePayment = (orderKey, payment_method, payment_instrument = null, orderType = null, orderResp = null, translations = null) => dispatch => {

    if (payment_method.includes('online') && orderResp && orderResp.ppResp && orderResp.ppResp.localPayment) {
        // Kiosk card payment on a local Datecs terminal (USB) — no PSP redirect.
        dispatch(clearCartLocal());

        startDatecsKioskPayment({
            amount: orderResp.ppResp.amount,
            orderKey: orderResp.ppResp.uuid,
            translations,
        });
    }
    else if (payment_method.includes('online') && orderResp && orderResp.ppResp && orderResp.ppResp.redForm) {
        dispatch(clearCartLocal());

        const container = document.createElement('div');
        container.innerHTML = orderResp.ppResp.redForm;
        document.body.appendChild(container);

        const form = container.querySelector('form');
        form.submit();
    }
    else if (payment_method.includes('online') && orderResp && orderResp.ppResp && orderResp.ppResp.redLink) {
        dispatch(clearCartLocal());

        window.location.replace(orderResp.ppResp.redLink);
    }
    else if (payment_method == 'epay') {
        dispatch(setCartModalOpenedState(false));
        dispatch(setProcessingPaymentModalOpened(true));

        if (payment_instrument) {
            dispatch(initiateEpayOrderOneTouch(orderKey, payment_instrument))
        } else {
            dispatch(initiateEpayOrder(orderKey))
        }
    } else {
        dispatch(clearCartLocal());

        let successMsg = 'Успешно направена поръчка';
        if (orderType == 'delivery') {
            successMsg = Utils.getSetting('seccess_message_delivery_order')
        } else if (orderType == 'pickup') {
            successMsg = Utils.getSetting('seccess_message_pickup_order')
        } else if (orderType == 'room') {
            successMsg = translations && translations.messages.notifications && translations.messages.notifications.order_sent_success || "Поръчката ви скоро ще бъде сервирана";
        }
        dispatch(addSuccessMessage(successMsg))

        // Kiosk: print the order receipt on the built-in printer for non-card
        // orders (cash / on-room-bill). Card orders print after the terminal
        // confirms (see datecsKioskPayment). No-ops unless kiosk + setting on.
        const uuid = orderKey || (orderResp && (orderResp.key || orderResp.uuid));
        maybePrintKioskReceipt(uuid, translations);
    }
}

export const clearOrderStatus = () => dispatch => {
    dispatch({ type: CLEAR_ORDER });
}

// Изчиства само показаните поръчки (без да пипа токена/сесията) — за киоск,
// за да изчезне поръчката след затваряне на модала за следващия клиент.
export const clearOrders = () => dispatch => {
    dispatch({ type: GET_ORDERS, payload: [] });
}

export const getAllProductsAccordingToPlaces = (showLoading = 0) => dispatch => {
    if (showLoading) {
        dispatch({ type: LOADING_START });
    }

    let url = 'productsAccordingToPlaces?active=1';
    // if (placeId !== 0) {
    //     url += '&place_id=' + placeId;
    // }

    axios.get(API_URL + url)
        .then(res => {
            dispatch({
                type: GET_ALL_PRODUCTS,
                payload: res.data
            });
            if (showLoading) {
                dispatch({ type: LOADING_END });
            }
        });
}

export const getAllProducts = (showLoading = 0, placeId = 0) => dispatch => {
    if (showLoading) {
        dispatch({ type: LOADING_START });
    }

    let url = 'products?active=1';
    if (placeId !== 0) {
        url += '&place_id=' + placeId;
    }

    axios.get(API_URL + url)
        .then(res => {
            dispatch({
                type: GET_ALL_PRODUCTS,
                payload: res.data
            });
            if (showLoading) {
                dispatch({ type: LOADING_END });
            }
        });
}

export const getOrders = (uToken) => dispatch => {
    const userToken = uToken ? uToken : Auth.getUserToken();
    if (!userToken) {
        dispatch({
            type: GET_ORDERS,
            payload: []
        });
        return;
    }

    axios.get(API_URL + 'orders/by_table_session/' + userToken + `?timestamp=${new Date().getTime()}`)
        .then(result => {
            if (result.data.error) {
                dispatch({
                    type: GET_ORDERS,
                    payload: []
                })
            } else {
                dispatch({
                    type: GET_ORDERS,
                    payload: sortBy(result.data, ['id']).reverse()
                })
            }
        })
        .catch(err => {
            let errorData = err.response.data;
            if (errorData && errorData.error && errorData.error.errors && errorData.error.errors[0] && errorData.error.errors[0].message && errorData.error.errors[0].message == 'Invalid session') {
                // Киоск: не махаме токена (Auth.removeUserToken е no-op в киоск), а се
                // само-лекуваме - презареждаме входния (токен) URL, за да ни издаде
                // сървърът свежа сесия. Пазим се от цикъл с еднократен флаг за таба.
                if (Auth.isKioskMode()) {
                    let entryUrl = Auth.getKioskEntryUrl();
                    try {
                        if (entryUrl && window.sessionStorage.getItem('tabl_kiosk_session_reload') != '1') {
                            window.sessionStorage.setItem('tabl_kiosk_session_reload', '1');
                            window.location.href = entryUrl;
                            return;
                        }
                    } catch (e) { /* sessionStorage unavailable */ }
                }

                Auth.removeUserToken();
                dispatch({
                    type: GET_ORDERS,
                    payload: []
                });
            }
        })
}

export const changeSelectedCartTab = (selectedCartTab) => dispatch => {
    dispatch({
        type: CHANGE_SELECTED_CART_TAB,
        payload: selectedCartTab
    });
}

export const removeUserTokenAndOrder = () => dispatch => {
    Auth.removeUserToken();
    dispatch({
        type: GET_ORDERS,
        payload: []
    });
}


export const clearBillWanted = () => dispatch => {
    dispatch({ type: CLEAR_BILL_ASKED, });
}

export const askForBill = (paymentMethod, placeId) => dispatch => {
    // console.log('placeId',placeId);
    const userToken = Auth.getUserToken();
    if (!userToken) {
        dispatch({
            type: BILL_ASKED,
            payload: false
            // payload: "Сметката ви е поискана успешно." //No translation needed
        });
        return;
    }

    dispatch({ type: LOADING_CART_START });

    axios
        .put(API_URL + `orders/by_table_session/${userToken}/bill_wanted`,
            {
                status: true,
                paymentMethod: paymentMethod,
                placeId: placeId || Auth.getOpenedPlace()
            }
        )
        .then(res => {
            dispatch({
                type: BILL_ASKED,
                payload: res.data
                // payload: "Сметката ви е поискана успешно." //No translation needed
            })
            dispatch(getOrders());

            // this.getOrders();
            dispatch({ type: LOADING_CART_END });
            Auth.updateUserTokenExpire(BILL_WANTED_EXPIRE_TIME_MINUTES);

            window.localStorage.setItem('bill_wanted', 1);
        })
        .catch(err => {
            dispatch({ type: LOADING_CART_END });
            dispatch({
                type: BILL_ASKED,
                payload: false
            })
        });
}



export const setProductPageId = (productId) => dispatch => {
    dispatch({
        type: SET_PRODUCT_PAGE_ID,
        payload: productId
    });
}

export const removeProductPageId = () => dispatch => {
    dispatch({
        type: REMOVE_PRODUCT_PAGE_ID
    });
}

export const setCommentModalData = (open, itemName, itemProductVariantId, cartItemUuid = '') => dispatch => {

    //     openCommentModal
    // commentModalTitle
    // commentVariantId
    // commentCartItemUuid (set when commenting a specific cart line; empty from the product page)

    dispatch({
        type: OPEN_COMMENT_MODAL,
        payload: open
    });
    dispatch({
        type: COMMENT_MODAL_TITLE,
        payload: itemName
    });
    dispatch({
        type: COMMENT_VARIANT_ID,
        payload: itemProductVariantId
    });
    dispatch({
        type: COMMENT_CART_ITEM_UUID,
        payload: cartItemUuid
    });
}


export const closePaymentTypeModal = () => dispatch => {
    dispatch({
        type: PAYMENT_TYPE_MODAL_OPENED,
        payload: false
    });
}

export const openPaymentTypeModal = () => dispatch => {
    dispatch({
        type: PAYMENT_TYPE_MODAL_OPENED,
        payload: true
    });
}

export const setDisabledMakeOrderButton = (status) => dispatch => {
    dispatch({
        type: SET_DISABLED_MAKE_ORDER_BUTTON,
        payload: status
    });
}